import { render, staticRenderFns } from "./UserSettingScale.vue?vue&type=template&id=45676d1b&scoped=true&"
import script from "./UserSettingScale.vue?vue&type=script&lang=js&"
export * from "./UserSettingScale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45676d1b",
  null
  
)

export default component.exports